module.exports = __webpack_public_path__ + "img/gb93.prt.b63929d8.jpg";